var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mt-2 sm:mt-0 sm:col-span-2" }, [
    _c("div", { staticClass: "inline-block relative cursorZoom" }, [
      _c("img", {
        staticClass: "h-20 w-20 rounded-md object-cover",
        attrs: { src: _vm.imageLink, alt: "" },
      }),
      _c(
        "div",
        {
          staticClass:
            "cursor-pointer border border-gray-400 hover:border-gray-600 deleteImgButton h-6 w-6 flex justify-center items-center rounded-full bg-white",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.remove.apply(null, arguments)
            },
          },
        },
        [_c("CrossIcon", { staticClass: "text-primary-500 h-5 w-5" })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }